<template>
  <div>
    <BackToTopButton />
    <Header headerClass="white" />
    <div class="main">
      <div class="tab" :style="stickyStyle" :class="stickyClass">
        <div class="tabbox">
          <div
            v-for="(item, index) in nav"
            :key="index"
            class="tabitem"
            :class="{ active: item.id == carId }"
            @click="changeType(item)"
          >
            {{ item.carModel }}
          </div>
        </div>
      </div>

      <div class="picture" :class="stickyClass">
        <img
          :style="bigimg(index)"
          v-for="(item, index) in imglist"
          v-lazy="
            item.picUrl + '?x-image-process=image/resize,m_lfit,h_600,w_600'
          "
          :key="index"
          alt=""
          @click="clickImg(index)"
        />
      </div>
    </div>
    <ImageViewer
      v-model="show"
      :cur="cur"
      :list="imglist.map((item) => item.picUrl)"
    />
    <Floor />
  </div>
</template>

<script>
import Header from "@components/Header/index.vue";
import Floor from "@components/Floor/index.vue";
import ImageViewer from "@components/ImageViewer/index.vue";
import BackToTopButton from "@components/BackToTopButton/index.vue";
import { getTabManage, getPicList } from "@api/picture";
import utils from "@utils";
export default {
  name: "Picture",
  components: {
    Header,
    Floor,
    ImageViewer,
    BackToTopButton,
  },
  data() {
    return {
      show: false,
      cur: -1,
      nav: [],
      carId: null,
      imglist: [],
      topOffset: 48,
      sticky: false,
    };
  },
  created() {
    const type = utils.getQueryString("type") || "V09";
    getTabManage().then((r) => {
      const dta = r.data || [];
      this.nav = dta;
      const obj = dta.find((i) => i.carModel == type) || {};
      this.carId = obj.id || (dta[0] ? dta[0].id : null);
      this.carId && this.getImgList();
    });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getImgList() {
      getPicList({ id: this.carId }).then((r) => {
        this.imglist = r.data || [];
        window.scrollTo(0, 0);
      });
    },
    changeType(item) {
      this.carId = item.id;
      this.getImgList();
    },
    clickImg(index) {
      this.cur = index;
      this.show = true;
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.sticky = scrollTop > this.topOffset; // 根据滚动位置判断是否应用吸顶样式
    },
  },
  computed: {
    bigimg() {
      return function(index) {
        return index % 6 == 0
          ? {
              gridColumn: `span 2`,
              gridRow: `span 2`,
            }
          : index % 6 == 5
          ? {
              gridColumn: `2 / span 2`,
              gridRow: `${index - ((index + 1) / 6) * 2} / span 2`,
            }
          : {};
      };
    },
    stickyClass() {
      return {
        sticky: this.sticky,
      };
    },
    stickyStyle() {
      return {
        top: this.sticky ? `${this.topOffset}px` : "auto",
      };
    },
  },
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
.main {
  padding: 60px 0;
  width: 944px;
  margin: 0 auto;
  display: flex;
  overflow: hidden;
  flex: 1;
  ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  @include media(
    (
      $md: (
        flex-direction: column,
        width: 100%,
        padding: 0,
      ),
    )
  );
  .tab {
    flex: 0 0 244px;
    height: 100%;
    background-color: #fff;
    z-index: 2;
    &.sticky {
      position: fixed;
      padding-top: 32px;
      @include media(
        (
          $md: (
            padding-top: 0,
          ),
          $sm: (),
        )
      );
    }
    @include media(
      (
        $md: (
          display: flex,
          gap: 32px,
          width: 100%,
          height: auto,
          flex: 1,
        ),
      )
    );
    .tabitem {
      height: 60px;
      display: flex;
      align-items: center;
      padding: 0 16px;
      color: #878889;
      font-size: 18px;
      line-height: 28px;
      cursor: pointer;
      white-space: nowrap;
      font-family: "Saira-Regular";
      @include media(
        (
          $md: (
            font-size: 16px,
            line-height: 26px,
            height: 26px,
            padding: 0,
          ),
        )
      );
    }
    .active {
      color: #131415;
      &::before {
        content: "";
        display: inline-block;
        width: 3px;
        height: 28px;
        position: absolute;
        left: 0;
        background-color: #131415;
        @include media(
          (
            $md: (
              display: none,
            ),
          )
        );
      }
    }
    .tabbox {
      position: relative;
      @include media(
        (
          $md: (
            display: flex,
            gap: 32px,
            width: 100%,
            height: auto,
            padding: 16px 48px,
            overflow: hidden,
            overflow-x: scroll,
          ),
          $sm: (
            gap: 24px,
            padding: 16px,
          ),
        )
      );
      &::before {
        content: "";
        display: inline-block;
        width: 2px;
        height: calc(100% - 40px);
        position: absolute;
        left: 0;
        top: 20px;
        background-color: #eee;

        @include media(
          (
            $md: (
              display: none,
            ),
          )
        );
      }
    }
  }
  .picture {
    flex: 1;
    overflow: hidden;
    overflow-y: auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 32px;
    &.sticky {
      margin-left: 244px;

      @include media(
        (
          $md: (
            margin-left: 0,
          ),
        )
      );
    }
    @include media(
      (
        $md: (
          grid-gap: 20px,
          padding: 0 48px,
        ),
        $sm: (
          grid-gap: 13px,
          padding: 0 16px,
        ),
      )
    );
    > img {
      width: 100%;
      height: 100%;
      aspect-ratio: 1;
      object-position: center center;
      object-fit: cover;
      cursor: pointer;
    }
  }
}
</style>
